import { CustomLoadingOverlayProps } from 'ag-grid-react';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';
import { LoadingIndicator } from '../loading-indicator/LoadingIndicator';

function ErrorOverlay(error: string) {
  return (
    <div
      className="table-overlay-content table-overlay-content--error"
      data-testid="table-error-overlay"
    >
      <GoogleFontIcon name="report" />
      {error}
    </div>
  );
}

export function CustomLoadingOverlay({
  error,
}: CustomLoadingOverlayProps & { error?: string }) {
  return error
    ? ErrorOverlay(error)
    : LoadingIndicator({
        size: '2.25em',
        'data-testid': 'table-loading-indicator',
      });
}

export function NoRowsOverlay() {
  return (
    <div
      className="table-overlay-content table-overlay-content--empty"
      data-testid="table-no-rows-overlay"
    >
      No data found
    </div>
  );
}
